"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var language = {};
language.translations = {};
language.translations.options = {
  months: {
    1: 'Январь',
    2: 'Февраль',
    3: 'Март',
    4: 'Апрель',
    5: 'Май',
    6: 'Июнь',
    7: 'Июль',
    8: 'Август',
    9: 'Сентябрь',
    10: 'Октябрь',
    11: 'Ноябрь',
    12: 'Декабрь'
  },
  shortMonths: {
    1: 'Янв',
    2: 'Фев',
    3: 'Мар',
    4: 'Апр',
    5: 'Май',
    6: 'Июн',
    7: 'Июл',
    8: 'Авг',
    9: 'Сен',
    10: 'Окт',
    11: 'Ноя',
    12: 'Дек'
  },
  weekdays: {
    1: 'Понедельник',
    2: 'Вторник',
    3: 'Среда',
    4: 'Четверг',
    5: 'Пятница',
    6: 'Суббота',
    7: 'Воскресенье'
  },
  shortWeekdays: {
    1: 'Пон',
    2: 'Вто',
    3: 'Сре',
    4: 'Чет',
    5: 'Пят',
    6: 'Суб',
    7: 'Вос'
  }
};
language.translations.global = {};
var _default = language;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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